export enum StateEnum {
    Add = 0,
    Merge = 1,
    DeletedMerge = 2,
    Edited = 3,
    Deleted = 4,
    Save = 5,
    SaveMerge = 6,
    EditWithoutChange = 7, // 2ستونی
    EditWithChangeIncrease = 8, // 3ستونی
    DeletedForDuplicateFactor = 9,
    DeletedForTabletMerge = 10
}

export enum ActionStateEnum {
    Save = 0,
    Merge = 1,
    Deleted = 2,
    Edited = 3,
}
